define(['app/modules/forms', 'app/modules/utilities'], function(Forms, Util) {
  const userMetaBlock = document.querySelector("meta[name='current-user']");

  const signIn = function(form, prefix, callback){
    let modal = form.parents('.modal#sign-in-modal');
    modal.find('.loading-wrapper').prepend('<div class="ca-loading"></div>');

    $.ajax({
      dataType: 'json',
      type: form.attr('method'),
      url: form.attr('action'),
      data: form.serialize(),
      success: function(result){
        $('input[name=authenticity_token]').val(result.token);
        $('meta[name=csrf-token]').attr('content', result.token);
        Forms.hideErrors(form);
        modal.modal('hide');
        modal.find('.ca-loading').remove();
        if (callback) {
          callback();
        } else {
          window.location.reload();
        }
      },
      error: function(result){
        Forms.hideErrors(form);
        Forms.showErrors(form, [], prefix, Util.renderErrorHtml(Forms.getError(result)));
        Forms.redirectTo(result);
        modal.find('.ca-loading').remove();
      }
    });
  };

  const isSignedIn = () => Boolean(userMetaBlock)
  const id = () => userMetaBlock ? userMetaBlock.dataset.id : null

  return {
    signIn: signIn,
    isSignedIn: isSignedIn,
    id: id
  };
});
